import axios from 'axios';
import store from '@/store/store';
import { actions as _act } from '@/models/store.actions';

export const cloudKeySignService = { signData, signFiles, signHashes, getKeyType };

let model = {
  get baseUrl() {
    return store.getters[_act.SETT_GET_APIURLGET];
  },
  controller: 'cloud-key'
};

function extract(r) {
  return r.data;
}

async function signData(
  certificate: string,
  privateKeyPassword: string,
  data: string,
  googleReCaptchaResponse: string = '',
  recaptchaType: string = '') {
  return axios
    .post(
      `${model.baseUrl}${model.controller}/sign-data`,
      { certificate, privateKeyPassword, data, googleReCaptchaResponse, recaptchaType })
    .then(extract);
}

async function signFiles(
  certificate: string,
  privateKeyPassword: string,
  files: string[],
  googleReCaptchaResponse: string = '',
  recaptchaType: string = '') {
  return axios
    .post(
      `${model.baseUrl}${model.controller}/sign-files`,
      { certificate, privateKeyPassword, files, googleReCaptchaResponse, recaptchaType })
    .then(extract);
}

async function signHashes(
  certificate: string,
  privateKeyPassword: string,
  hashes: string[],
  googleReCaptchaResponse: string = '',
  recaptchaType: string = '') {
  return axios
    .post(
      `${model.baseUrl}${model.controller}/sign-hashes`,
      { certificate, privateKeyPassword, hashes, googleReCaptchaResponse, recaptchaType })
    .then(extract);
}

async function getKeyType(certificate: string, googleReCaptchaResponse: string = '', recaptchaType: string = ''): Promise<number> {
  let { data } = await axios
    .post<number>(
      `${model.baseUrl}${model.controller}/certificate/key-type`,
      { certificate, googleReCaptchaResponse, recaptchaType });

  return data;
}
